import { type GalleryFilter, takers } from './gallery-model.ts';

/** Photos or videos, whose, and which first, over a job's (or a customer's) photos. */
export function GalleryTools({
  items,
  value,
  onChange,
}: {
  items: readonly { kind: string; addedBy: string | null; capturedAt: string | null }[];
  value: GalleryFilter;
  onChange: (f: GalleryFilter) => void;
}) {
  const people = takers(items);
  const videos = items.some((x) => x.kind === 'video');
  return (
    <div className="row gallery-tools">
      {videos && (
        <label className="small">
          Show{' '}
          <select
            value={value.kind}
            onChange={(e) => onChange({ ...value, kind: e.target.value as GalleryFilter['kind'] })}
          >
            <option value="all">Photos and videos</option>
            <option value="photo">Photos</option>
            <option value="video">Videos</option>
          </select>
        </label>
      )}
      {people.length > 1 && (
        <label className="small">
          Taken by{' '}
          <select value={value.by} onChange={(e) => onChange({ ...value, by: e.target.value })}>
            <option value="">Everyone</option>
            {people.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </label>
      )}
      <label className="small">
        Order{' '}
        <select
          value={value.sort}
          onChange={(e) => onChange({ ...value, sort: e.target.value as GalleryFilter['sort'] })}
        >
          <option value="newest">Newest first</option>
          <option value="oldest">Oldest first</option>
        </select>
      </label>
    </div>
  );
}
